<template>
  
  <li :id="$vnode.key" class="form-field draggable px-3 py-1 m-2" draggable="true" :style="{transform:'rotate(' + rotation + ')'}">
     {{ $t(iKey('personal_upstander_section', 'personal_upstander', $vnode.key)) }}
  </li>
  
</template>

<script>
import Draggabilly from 'draggabilly'

export default {
  name: 'DraggableTerm',
  data: function(){
    return {
      rotation: '0deg'
    }
  },
  props: [
    'term',
    'dropzone'
  ],
  mounted(){
      const degArr = ['-3deg', '3deg', '1deg', '-1deg'];
      this.$data.rotation = degArr[Math.floor(Math.random()*degArr.length)];

      var draggie = new Draggabilly( document.querySelector('#' + this.$vnode.key), {
        containment: '#personal_upstander'
    });

    draggie.on('dragMove', function(event, pointer){
        pointer.target.getBoundingClientRect()
        this.$emit('dragged', pointer.target.getBoundingClientRect(), this.$props.dropzone);
    }.bind(this))

    draggie.on('dragEnd', function(event, pointer){
        this.$emit('dropped', pointer.target, this.$props.dropzone)
    }.bind(this))

    draggie.on('staticClick', function(event, pointer){
        this.$emit('clicked', pointer.target, this.$props.dropzone)
    }.bind(this))
    
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .draggable{
        background-color: white;
        color: black;
        display: inline-block;
        transition: opacity, background-color 0.3s;
        cursor: move;
        z-index: 1;
    }
    .draggable.is-pointer-down,
    .draggable.is-dragging{
        opacity: 0.9;
        z-index: 2;
    }
    .draggable.dropped {
        background-color: rgba(255,255,255,0);
    }
</style>
